import React, { useState } from 'react';
import wordmark from '../../assets/recouvro-wordmark.png';
import './Brand.css';

// The house and swoosh of the Recouvro logo as vectors: same drawing as the mobile app
// (mobile/src/components/Mark.tsx), the icons and the agency app (hokuef/src/components/brand).
const HOUSE = 'M48 292 L356 44 L430 102 L430 70 L505 70 L505 162 L660 286 L580 286 L356 106 L190 242 L208 242 L208 335 C300 295 430 280 535 287 C400 290 260 330 160 425 L160 292 Z';
const SWOOSH = 'M128 550 C250 390 480 310 690 297 C500 320 300 420 208 577 Z';
const WORDMARK_RATIO = 1175 / 182;

function Mark({ height }) {
  return (
    <svg className="brand-mark" viewBox="40 36 660 550" height={height} width={height * 1.2} aria-hidden="true">
      <path className="brand-house" fill="#fff" d={HOUSE} />
      <path className="brand-swoosh" fill="#000" d={SWOOSH} />
    </svg>
  );
}

/** The logo bar (blue, house, RECOUVRO). Plays its animation when shown, and again on hover. */
export function BrandLogo({ height = 36, className = '' }) {
  const [play, setPlay] = useState(0);
  return (
    <span
      key={play}
      className={`brand-logo brand-animate ${className}`}
      style={{ height, borderRadius: height * 0.22, padding: `0 ${height * 0.32}px`, gap: height * 0.22 }}
      onMouseEnter={() => setPlay((n) => n + 1)}
    >
      <Mark height={height * 0.78} />
      <img src={wordmark} alt="Recouvro" style={{ height: height * 0.42, width: height * 0.42 * WORDMARK_RATIO }} />
    </span>
  );
}

/** Loading indicator: the blue icon, the swoosh sweeping in a loop. */
export function BrandLoader({ size = 44 }) {
  return (
    <span className="brand-icon brand-loader" style={{ width: size, height: size, borderRadius: size * 0.22 }} role="progressbar" aria-label="Chargement">
      <Mark height={size * 0.62} />
    </span>
  );
}
